import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import { PlaceholderTableIcon } from './PlaceholderTableIcon';

interface Props {
  nodeTitle: string;
}

export const PathInspectorTablePlaceholder: FC<Props> = (props) => {
  const msg = useLocale();
  return (
    <div className='px-lgu-12 py-5'>
      <p className='m-0 pb-5 font-bold'>
        <span className='block'>{props.nodeTitle}</span>
        <span className='block'>
          {msg.deviceView.devicePathLookup.placeholder.tableTitle}
        </span>
      </p>
      <div className='text-center'>
        <PlaceholderTableIcon title={null} width={80} height={54} />
      </div>
    </div>
  );
};
